import { createGlobalStyle } from 'styled-components'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import Home from './pages/Home'
import { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: #00ffd5;
    --primary-glow: rgba(0, 255, 213, 0.15);
    --secondary-color: #6b4bff;
    --secondary-glow: rgba(107, 75, 255, 0.15);
    --accent-color: #ff4b8b;
    --accent-glow: rgba(255, 75, 139, 0.15);
    --background-dark: #0c0f1d;
    --background-light: #1a1f35;
    --surface-color: rgba(255, 255, 255, 0.05);
    --text-primary: #ffffff;
    --text-secondary: rgba(255, 255, 255, 0.7);
    --border-color: rgba(100, 255, 218, 0.1);
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 80px;
    height: 100%;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: var(--background-dark);
    background-image: 
      radial-gradient(circle at 15% 50%, var(--primary-glow) 0%, transparent 25%),
      radial-gradient(circle at 85% 30%, var(--secondary-glow) 0%, transparent 25%),
      radial-gradient(circle at 50% 80%, var(--accent-glow) 0%, transparent 25%);
    background-attachment: fixed;
    background-size: 100% 100%;
    color: var(--text-primary);
    overflow-x: hidden;
    min-height: 100vh;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  a {
    color: var(--text-primary);
    text-decoration: none;
    margin: 0 1rem;
    transition: color 0.3s ease;
    
    &:hover {
      color: var(--primary-color);
    }
  }
`

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

function App() {
  const isMobile = useIsMobile();
  const theme = {
    isMobile
  };

  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('company.name') + ' - ' + t('company.slogan')
  }, [t])

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Navigation />
      <MainContent>
        <Home />
      </MainContent>
      <Footer />
    </ThemeProvider>
  )
}

export default App
